
export default {
    ViewOrderDetails: (data) => window.axios.get(`order/${data.order_id}`, data),
    SubscriptionDetail: (data) => window.axios.get(`subscription/${data.subscription_id}`, data),
    SubscriptionRestartPaused: (data, subscription_id) => window.axios.post(`subscription/${subscription_id}/pause-restart`, data),
    UpdateSubscription: (data, subscription_id) => window.axios.put(`subscription/${subscription_id}/quantity`, data),
    CancelSubscription: (data) => window.axios.post(`subscription/${data.subscription_id}/cancel`, data),
    GenrateInvoice: (data) => window.axios.post('generate_subscription_invoice', data),
}